import { Component } from '@angular/core';

/**
 * Settings page that groups email accounts, calendar accounts and meeting tools.
 * Each section is rendered by its own component so they keep loading and connecting independently.
 */
@Component({
    selector: 'sfx-accounts-settings',
    templateUrl: './accounts-settings.component.html',
    styleUrls: ['./accounts-settings.component.scss']
})
export class AccountsSettingsComponent {}
